import React, { useMemo } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import Group from "../../../ServicosAcolhimento/Visualizar/Group";
import { useEffect, useState } from "react";
import CriancaService from "../../../../../main/services/CriancaService";
import { Tooltip } from "@chakra-ui/react";
import { IconeDownload } from "../../../../components/IconeDownload";
import LoadingSpinner from "../../../../components/LoadingSpinner";

export const VisualizarPageProfissionalizacao = ({
  id,
  setIsTrueVisualizar,
  initialValues,
  setInitialValues,
  url,
}) => {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(true);
  const fakeFile = useMemo(() => {
    const blobData = new Blob([], { type: "application/octet-stream" });
    return new File([blobData], "Currículo Vitae", {
      type: "application/octet-stream",
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    CriancaService.getProfissionalizacao(id)
      .then((res) => {
        if (res.data) {
          setData(res.data);

          setInitialValues({
            curriculoVitae: res.data.curriculoVitae,
            cursoProfissionalizante: res.data.cursoProfissionalizante,
            jovemAprendiz: res.data.jovemAprendiz,

            trabalho: res.data.trabalho,
            estagio: res.data.estagio,
            nomeEmpresa: res.data.nomeEmpresa ? res.data.nomeEmpresa : "",

            originalAnexoCurriculo:
              res.data.curriculoVitae === "S" ? res.data.anexoCurriculo : null,
            anexoCurriculo: null,

            originalCursoProfissionalizante:
              res.data.cursoProfissionalizante === "S"
                ? res.data.anexoCursoProfissionalizante
                : null,
            anexoCursoProfissionalizante: null,

            originalAnexoJovemAprendiz:
              res.data.jovemAprendiz === "S"
                ? res.data.anexoAnexoProgramaJovemAprendiz
                : null,
            anexoProgramaJovemAprendiz: null,
          });

          if (url.includes("editar")) {
            setIsTrueVisualizar(false);
          } else {
            setIsTrueVisualizar(true);
          }
        } else {
          setIsTrueVisualizar(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsTrueVisualizar(false);
        setLoading(false);
      });
  }, [id, fakeFile, setInitialValues, setIsTrueVisualizar, url]);

  const getAnexosProf = (id, opcao) => {
    CriancaService.getAnexo(id, opcao)
      .then((res) => {
        const downloadUrl = res.config.url;
        window.open(downloadUrl, "_blank");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return !loading ? (
    <Group title="Profissionalização">
      <Flex mt="17px" direction={"column"} gap="18px">
        <Flex
          alignItems={"center"}
          justifyContent={"space-between"}
          border={"solid 1px var(--chakra-colors-gray-200)"}
          py={5}
          px={2}
        >
          <Flex gap={2}>
            <Text as="b">Possui Curso Profissionalizante?</Text>
            <Text>{data.cursoProfissionalizante === "S" ? "Sim" : "Não"}</Text>
          </Flex>
          {data?.cursoProfissionalizante === "S" && (
            <Flex alignItems={"center"} gap={4} mr={5}>
              <Text as="b">Baixar Certificado de Curso Profissionalizante</Text>
              {data?.possuiAnexoCursoProfissionalizante ? (
                <button
                  type="button"
                  onClick={() =>
                    getAnexosProf(
                      data.anexoCursoProfissionalizante.id,
                      "download"
                    )
                  }
                >
                  <IconeDownload />
                </button>
              ) : (
                ""
              )}
            </Flex>
          )}
        </Flex>
        <Flex
          gap={2}
          alignItems={"center"}
          border={"solid 1px var(--chakra-colors-gray-200)"}
          py={5}
          px={2}
        >
          <Text as="b">Trabalha Atualmente?</Text>
          <Text>{data.trabalho === "S" ? "Sim" : "Não"}</Text>
        </Flex>
        <Flex
          gap={2}
          alignItems={"center"}
          border={"solid 1px var(--chakra-colors-gray-200)"}
          py={5}
          px={2}
        >
          <Text as="b">Faz Estágio?</Text>
          <Text>{data.estagio === "S" ? "Sim" : "Não"}</Text>
        </Flex>

        <Flex
          justifyContent={"space-between"}
          border={"solid 1px var(--chakra-colors-gray-200)"}
          py={5}
          px={2}
        >
          <Flex gap={2}>
            <Text as="b">Matriculado no Programa Jovem Aprendiz?</Text>
            <Text>{data.jovemAprendiz === "S" ? "Sim" : "Não"}</Text>
          </Flex>

          {data?.jovemAprendiz === "S" && (
            <Flex alignItems={"center"} gap={4} mr={5}>
              <Text as="b">Baixar inscrição no Programa Jovem Aprendiz</Text>
              {data.possuiAnexoProgramaJovemAprendiz ? (
                <button
                  type="button"
                  onClick={() =>
                    getAnexosProf(
                      data.anexoAnexoProgramaJovemAprendiz.id,
                      "download"
                    )
                  }
                >
                  <IconeDownload />
                </button>
              ) : (
                ""
              )}
            </Flex>
          )}
        </Flex>
        {data.nomeEmpresa ? (
          <Flex
            gap={2}
            alignItems={"center"}
            border={"solid 1px var(--chakra-colors-gray-200)"}
            py={5}
            px={2}
          >
            <Text as="b">Nome da Empresa?</Text>
            <Text>
              <Tooltip
                label={`${
                  data.nomeEmpresa.length > 120 ? `${data.nomeEmpresa}` : ""
                }`}
              >
                {data.nomeEmpresa.length > 120
                  ? data.nomeEmpresa.slice(0, 120) + "..."
                  : data.nomeEmpresa}
              </Tooltip>
            </Text>
          </Flex>
        ) : (
          ""
        )}
        <Flex
          alignItems={"center"}
          justifyContent={"space-between"}
          border={"solid 1px var(--chakra-colors-gray-200)"}
          py={5}
          px={2}
        >
          <Flex gap={2}>
            <Text as="b">Possui Currículo Vitae?</Text>
            <Text>{data.curriculoVitae === "S" ? "Sim" : "Não"}</Text>
          </Flex>
          {data.curriculoVitae === "S" && (
            <Flex alignItems={"center"} gap={4} mr={5}>
              <Text as="b">Baixar Currículo Vitae</Text>
              {data.possuiAnexoCurriculo ? (
                <button
                  type="button"
                  onClick={() =>
                    getAnexosProf(data.anexoCurriculo.id, "download")
                  }
                >
                  <IconeDownload />
                </button>
              ) : (
                ""
              )}
            </Flex>
          )}
        </Flex>
      </Flex>
    </Group>
  ) : (
    <Box mt={4}>
      <LoadingSpinner />
    </Box>
  );
};
